import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import API from "../services/api";

import "./Home.css";

import ProductCard from "../component/Product/ProductCard";
import Hero from "../component/Home/Hero/Hero";
import CategorySection from "../component/Home/CategorySection/CategorySection";
import WhyChooseUs from "../component/Home/WhyChooseUs/WhyChooseUs";


function Home({ setCartCount, isLoggedIn }) {

  const navigate = useNavigate();

  const [products, setProducts] = useState([]);
  const [wishlist, setWishlist] = useState({});


  // ==========================================
  // LOAD HOME DATA
  // ==========================================

  useEffect(() => {

    fetchProducts();

    // Wishlist requires authentication
    if (isLoggedIn) {
      fetchWishList();
    } else {
      setWishlist({});
    }

  }, [isLoggedIn]);


  // ==========================================
  // FETCH PRODUCTS
  // Public API
  // ==========================================

  const fetchProducts = async () => {

    try {

      const response = await API.get(
        "/api/products?page=0&size=20"
      );

      setProducts(response.data.content);

    } catch (error) {

      console.log(
        "Error fetching products:",
        error
      );

    }

  };


  // ==========================================
  // ADD TO CART
  // Login required
  // ==========================================

  const handleToCart = async (productId) => {

    // Guest user
    if (!isLoggedIn) {

      navigate("/login");

      return;
    }


    try {

      await API.post(
        `/api/cart?productId=${productId}&quantity=1`
      );


      const response = await API.get(
        "/api/cart"
      );


      setCartCount(
        response.data.length
      );


      alert("Added to cart");


    } catch (error) {

      console.log(error);

      alert("Failed to add to cart");

    }

  };


  // ==========================================
  // WISHLIST
  // Login required
  // ==========================================

  const handleWishList = async (
    productId,
    isAdded,
    setIsAdded
  ) => {

    // Guest user
    if (!isLoggedIn) {

      navigate("/login");

      return;
    }


    try {

      if (isAdded) {

        await API.post(
          `/api/wishlist/remove/${productId}`
        );

        setIsAdded(false);

      } else {

        await API.post(
          `/api/wishlist/add/${productId}`
        );

        setIsAdded(true);

      }

    } catch (error) {

      console.log(error);

      alert("WishList error");

    }

  };


  // ==========================================
  // FETCH WISHLIST
  // Only logged-in users
  // ==========================================

  const fetchWishList = async () => {

    try {

      const response = await API.get(
        "/api/wishlist"
      );


      const data = {};


      response.data.forEach(item => {

        data[item.product.id] = true;

      });


      setWishlist(data);


    } catch (error) {

      console.log(
        "Error fetching wishlist:",
        error
      );

    }

  };


  // ==========================================
  // UI
  // ==========================================

  return (

    <div className="page-container">

      <Hero />

      <CategorySection />


      <section className="products-section">

        <div className="section-heading">

          <h2>
            Trending Products
          </h2>

          <p>
            Discover our latest collection.
          </p>

        </div>


        <div className="products-grid">

          {products.map(product => (

            <ProductCard

              key={product.id}

              product={product}

              wishlist={wishlist}

              handleWishList={handleWishList}

              handleToCart={handleToCart}

              setWishlist={setWishlist}

            />

          ))}

        </div>

      </section>


      <WhyChooseUs />

    </div>

  );

}


export default Home;